var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9915_10585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 0.751953H1.25024C0.973682 0.751953 0.750244 0.975391 0.750244 1.25195V12.752C0.750244 13.0285 0.973682 13.252 1.25024 13.252H6.87525C6.94399 13.252 7.00025 13.1957 7.00025 13.127V12.252C7.00025 12.1832 6.94399 12.127 6.87525 12.127H1.87524V1.87695H12.1252V6.87695C12.1252 6.9457 12.1815 7.00195 12.2502 7.00195H13.1252C13.194 7.00195 13.2502 6.9457 13.2502 6.87695V1.25195C13.2502 0.975391 13.0268 0.751953 12.7502 0.751953ZM9.20806 8.36758L10.0237 7.55195C10.0402 7.53535 10.0517 7.51444 10.057 7.49161C10.0622 7.46878 10.0609 7.44493 10.0533 7.42279C10.0456 7.40065 10.0319 7.38111 10.0137 7.36637C9.99547 7.35164 9.97349 7.34231 9.95024 7.33945L7.14712 7.01133C7.06743 7.00195 6.99868 7.06914 7.00806 7.15039L7.33618 9.95352C7.34868 10.0566 7.47524 10.1004 7.54868 10.027L8.36743 9.2082L12.3706 13.2113C12.419 13.2598 12.4987 13.2598 12.5471 13.2113L13.2096 12.5488C13.2581 12.5004 13.2581 12.4207 13.2096 12.3723L9.20806 8.36758Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9915_10585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "97120/static/media/Select.6a5294f154e77a2c56201771552ead98.svg";
export { ForwardRef as ReactComponent };